import { ImageSource } from "@features/upload/types";
import { useImage } from "./useImage";

type ImageVariant = "profile" | "machinery" | "company" | "default";

interface IImageWithSkeleton {
  src?: ImageSource;
  alt?: string;
  variant?: ImageVariant;
  fallbackSrc?: string;
  imgClassName?: string;
  wrapperClassName?: string;
  skeletonClassName?: string;
  disableTransition?: boolean;
  fill?: boolean
}

export const ImageWithSkeleton = ({
  src,
  alt = "image",
  variant = "default",
  fallbackSrc,
  imgClassName = "object-cover",
  wrapperClassName = "w-full h-full bg-gray-200 overflow-hidden",
  skeletonClassName = "absolute inset-0 bg-gray-300 rounded-md animate-pulse",
  disableTransition = false,
  fill = false
}: IImageWithSkeleton) => {
  const { ref, resolvedSrc, loaded, onLoad, onError } = useImage({ src, variant, fallbackSrc });

  return (
    <div
      className={`
        ${fill ? "absolute inset-0 z-0" : "relative"}
        ${wrapperClassName}
      `}
    >
      {!loaded && <div className={`${skeletonClassName} z-10`} />}
      <img
        ref={ref}
        src={resolvedSrc}
        alt={alt}
        onLoad={onLoad}
        onError={onError}
        className={`relative z-0 w-full h-full ${imgClassName} ${disableTransition
          ? "opacity-100"
          : `transition-all duration-500 ${loaded ? "opacity-100 blur-0" : "opacity-0 blur-sm scale-105"}`
          }`}
      />
    </div>
  );
};